export const SOCKET_Connect = 'SOCKET_Connect'
export const SOCKET_Endpoint = 'SOCKET_Endpoint'
export const SOCKET_NewPeerState = 'SOCKET_NewPeerState'
export const SOCKET_PJSIPChannel = 'SOCKET_PJSIPChannel'
export const SOCKET_updateEndpoint = 'SOCKET_updateEndpoint'
export const SOCKET_DeleteEndpoint = 'SOCKET_DeleteEndpoint'
export const SOCKET_NewAgent = 'SOCKET_NewAgent'
export const SOCKET_RemoveAgent = 'SOCKET_RemoveAgent'
export const SOCKET_UpdateAgentStatus = 'SOCKET_UpdateAgentStatus'
export const SOCKET_NewQueueCall = 'SOCKET_NewQueueCall'
export const SOCKET_CallOnWait = 'SOCKET_CallOnWait'
export const SOCKET_callsMonitorOperador = 'SOCKET_callsMonitorOperador'
export const SOCKET_RemoveCallOnWait = 'SOCKET_RemoveCallOnWait'
export const SOCKET_ClickToCall = 'SOCKET_ClickToCall'
export const SOCKET_Hangup = 'SOCKET_Hangup'
export const SOCKET_LinkedIdEnd = 'SOCKET_LinkedIdEnd'
export const SOCKET_FullyBooted = 'SOCKET_FullyBooted'
export const SOCKET_ProtocolNew = 'SOCKET_ProtocolNew'
export const SOCKET_ProtocolOld = 'SOCKET_ProtocolOld'
export const SOCKET_HistoryOld = 'SOCKET_HistoryOld'
export const SOCKET_HistoryNew = 'SOCKET_HistoryNew'
export const GET_ALL_PEERS = 'GET_ALL_PEERS'
export const PREV_CALL_INDEX = 'PREV_CALL_INDEX'
export const NEXT_CALL_INDEX = 'NEXT_CALL_INDEX'
export const RESET_CALL_INDEX = 'RESET_CALL_INDEX'
export const PREV_CALL_INDEX_OPERADOR = 'PREV_CALL_INDEX_OPERADOR'
export const NEXT_CALL_INDEX_OPERADOR = 'NEXT_CALL_INDEX_OPERADOR'
export const RESET_CALL_INDEX_OPERADOR = 'RESET_CALL_INDEX_OPERADOR'
export const RESET_ENDPOINT = 'RESET_ENDPOINT'
export const UPDATE_ENDPOINT = 'UPDATE_ENDPOINT'
export const SOCKET_EndListAgent = 'SOCKET_EndListAgent'

export const SOCKET_NewQueueCallOnConnect ='SOCKET_NewQueueCallOnConnect'
export const SOCKET_CallOnWaitOnConnect ='SOCKET_CallOnWaitOnConnect'
export const SOCKET_UpdateAgentStatusOnConnect ='SOCKET_UpdateAgentStatusOnConnect'
export const SOCKET_NewAgentOnConnect ='SOCKET_NewAgentOnConnect'
export const SOCKET_PJSIPChannelOnConnect ='SOCKET_PJSIPChannelOnConnect'
export const SOCKET_EndpointOnConnect ='SOCKET_EndpointOnConnect'
